export default "__VITE_ASSET__ee152525__"